module.exports = __webpack_public_path__ + "img/img-scholarship@2x.47030025.jpg";